import { Helpers } from '../../helpers';
import { IScheduleBuildSetting } from '../../interfaces/ischedule-build-setting';
import { BatchProcessType } from '../batch-process-type';
import { DrillDesign } from '../drill-design';
import { Scenario } from '../scenario';
import { Schedule } from '../schedule';
import { ScheduleBuildEconomicsSetting } from '../schedule-build-economics-setting';
import { StimEfficiency } from '../stim-efficiency';

export class ScheduleBuildSettingBase {
  ScheduleBuildSettingId: number;
  ScenarioId: number;
  NewRigLineStart: Date | null;
  AllDrillGroupStart: Date | null;
  ScheduleBuildStart: Date | null;
  ScheduleBuildEnd: Date | null;
  ProdForecastStart: Date | null;
  ProdForecastEnd: Date | null;
  WaitTimeAllowance: number | null;
  DaysToAddForNewRig: number | null;
  BatchDrillRigMoveA: number | null;
  DrillRigPadMove: number | null;
  NonBatchDrillRigMove: number | null;
  BatchDrillRigMoveB: number | null;
  BaseLeadTime: number | null;
  AdditionalDaysPerWell: number | null;
  DrillSurfaceDuration: number | null;
  RigReleaseBuffer: number | null;
  PreStimDuration: number | null;
  RunTubingDuration: number | null;
  PercentAttainment: number | null;
  EffectiveDate: Date | null;
  DefaultStimEfficiencyId: number | null;
  CrewMoveTime: number | null;
  AllowableDaySlide: number | null;
  AvailableFracCrews: number | null;
  PostStimDurationAdditionalDays: number | null;
  DrillProductionDuration: number | null;
  DrillIntermediateDuration: number | null;
  DrillIntermediate2Duration: number | null;
  DefaultDrillTypeId: number | null;
  DefaultBatchProcessTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  HasSpudderRig: boolean;
  MaxWellsPerDrillGroup: number;
  MaxFracToProdGap: number;
  DrillFracInterferanceBuffer: number;

  ScheduleBuildEconomicsSettings_ScheduleBuildSetting?: Array<ScheduleBuildEconomicsSetting> | null;
  Schedules_ScheduleBuildSettings?: Array<Schedule> | null;
  Scenario?: Scenario;
  BatchProcessType?: BatchProcessType;
  DrillDesign?: DrillDesign;
  StimEfficiency?: StimEfficiency;

  constructor(item?: IScheduleBuildSetting) {
    if (item) {

      this.ScheduleBuildSettingId = item.ScheduleBuildSettingId;
      this.ScenarioId = item.ScenarioId;
      this.NewRigLineStart = item.NewRigLineStart ? new Date(item.NewRigLineStart) : null;
      this.AllDrillGroupStart = item.AllDrillGroupStart ? new Date(item.AllDrillGroupStart) : null;
      this.ScheduleBuildStart = item.ScheduleBuildStart ? new Date(item.ScheduleBuildStart) : null;
      this.ScheduleBuildEnd = item.ScheduleBuildEnd ? new Date(item.ScheduleBuildEnd) : null;
      this.ProdForecastStart = item.ProdForecastStart ? new Date(item.ProdForecastStart) : null;
      this.ProdForecastEnd = item.ProdForecastEnd ? new Date(item.ProdForecastEnd) : null;
      this.WaitTimeAllowance = item.WaitTimeAllowance;
      this.DaysToAddForNewRig = item.DaysToAddForNewRig;
      this.BatchDrillRigMoveA = item.BatchDrillRigMoveA;
      this.DrillRigPadMove = item.DrillRigPadMove;
      this.NonBatchDrillRigMove = item.NonBatchDrillRigMove;
      this.BatchDrillRigMoveB = item.BatchDrillRigMoveB;
      this.BaseLeadTime = item.BaseLeadTime;
      this.AdditionalDaysPerWell = item.AdditionalDaysPerWell;
      this.DrillSurfaceDuration = item.DrillSurfaceDuration;
      this.RigReleaseBuffer = item.RigReleaseBuffer;
      this.PreStimDuration = item.PreStimDuration;
      this.RunTubingDuration = item.RunTubingDuration;
      this.PercentAttainment = item.PercentAttainment;
      this.EffectiveDate = item.EffectiveDate ? new Date(item.EffectiveDate) : null;
      this.DefaultStimEfficiencyId = item.DefaultStimEfficiencyId;
      this.CrewMoveTime = item.CrewMoveTime;
      this.AllowableDaySlide = item.AllowableDaySlide;
      this.AvailableFracCrews = item.AvailableFracCrews;
      this.PostStimDurationAdditionalDays = item.PostStimDurationAdditionalDays;
      this.DrillProductionDuration = item.DrillProductionDuration;
      this.DrillIntermediateDuration = item.DrillIntermediateDuration;
      this.DrillIntermediate2Duration = item.DrillIntermediate2Duration;
      this.DefaultDrillTypeId = item.DefaultDrillTypeId;
      this.DefaultBatchProcessTypeId = item.DefaultBatchProcessTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.HasSpudderRig = item.HasSpudderRig;
      this.MaxWellsPerDrillGroup = item.MaxWellsPerDrillGroup;
      this.MaxFracToProdGap = item.MaxFracToProdGap;
      this.DrillFracInterferanceBuffer = item.DrillFracInterferanceBuffer;

      this.ScheduleBuildEconomicsSettings_ScheduleBuildSetting = Helpers.createClassArray(ScheduleBuildEconomicsSetting, item.ScheduleBuildEconomicsSettings_ScheduleBuildSetting);
      this.Schedules_ScheduleBuildSettings = Helpers.createClassArray(Schedule, item.Schedules_ScheduleBuildSettings);
      this.Scenario = new Scenario(item.Scenario);
      this.BatchProcessType = new BatchProcessType(item.BatchProcessType);
      this.DrillDesign = new DrillDesign(item.DrillDesign);
      this.StimEfficiency = new StimEfficiency(item.StimEfficiency);
    }
  }
}